export function canEditConnectionRoutes({
    schemaReadonly = false,
    templateReadonly = false,
    isPreviewing = false,
    isImporting = false,
    embedded = false,
} = {}) {
    return !schemaReadonly
        && !templateReadonly
        && !isPreviewing
        && !isImporting
        && !embedded
}
